export const publishersData = [
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "El Cronista",
        "URL": "cronista.com",
        "App": "Not Available",
        "Avails": 1937080000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "Letras",
        "URL": "letras.com",
        "App": "Not Available",
        "Avails": 760100000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "EDA TV",
        "URL": "edatv.news",
        "App": "Not Available",
        "Avails": 715760000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "List\u00edn Diario",
        "URL": "listindiario.com",
        "App": "Not Available",
        "Avails": 73120000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "Studio Sol Comunica\u00e7\u00e3o Digital",
        "URL": "cifraclub.com",
        "App": "com.studiosol.cifras",
        "Avails": 25220000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "TVNotas",
        "URL": "tvnotas.com",
        "App": "com.novix.tvnotas",
        "Avails": 25030000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "Titania Compa\u00f1\u00eda Editorial, S.L.",
        "URL": "elconfidencial.com",
        "App": "Not Available",
        "Avails": 19010000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "Weblogs SL",
        "URL": "xataka.com",
        "App": "Not Available",
        "Avails": 18010000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "Metro International",
        "URL": "publimetro.com",
        "App": "Not Available",
        "Avails": 16010000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "Fox Sports",
        "URL": "foxsports.com",
        "App": "Not Available",
        "Avails": 13000000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Hispanic",
        "Publisher": "Grupo God\u00f3",
        "URL": "lavanguardia.com",
        "App": "Not Available",
        "Avails": 11000000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "African American",
        "Publisher": "Blavity Inc.",
        "URL": "blavity.com",
        "App": "com.blavity.blavitytv",
        "Avails": 6186226240.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "African American",
        "Publisher": "G/O Media",
        "URL": "www.theroot.com",
        "App": "Not Available",
        "Avails": 3928915920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "African American",
        "Publisher": "Essence Communications Inc.",
        "URL": "www.essence.com",
        "App": "Not Available",
        "Avails": 1262641360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "African American",
        "Publisher": "BET Networks",
        "URL": "www.bet.com",
        "App": "com.bet.BETNow",
        "Avails": 1108466920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "African American",
        "Publisher": "Allen Media Group",
        "URL": "thegrio.com",
        "App": "com.thegrio.TheGrio",
        "Avails": 1035515680.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "African American",
        "Publisher": "Moguldom Media Group",
        "URL": "madamenoire.com",
        "App": "Not Available",
        "Avails": 640512720.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "African American",
        "Publisher": "Earl G. Graves Sr.",
        "URL": "www.blackenterprise.com",
        "App": "Not Available",
        "Avails": 630875240.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "African American",
        "Publisher": "iOne Digital",
        "URL": "bossip.com",
        "App": "com.moguldom.bossip",
        "Avails": 521138800.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "African American",
        "Publisher": "Diamond Diaspora Media",
        "URL": "atlantablackstar.com",
        "App": "Not Available",
        "Avails": 502766160.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Chinese",
        "Publisher": "Sing Tao News Corporation",
        "URL": "singtaousa.com",
        "App": "Not Available",
        "Avails": 492469800.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Chinese",
        "Publisher": "Seattle Chinese Post",
        "URL": "seattlechinesepost.com",
        "App": "Not Available",
        "Avails": 346814080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Chinese",
        "Publisher": "International Daily News",
        "URL": "chinesedailynews.com",
        "App": "Not Available",
        "Avails": 336138280.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Chinese",
        "Publisher": "Ming Pao Newspapers",
        "URL": "mingpaocanada.com",
        "App": "Not Available",
        "Avails": 327876960.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Chinese",
        "Publisher": "AsianWeek LLC",
        "URL": "asianweek.com",
        "App": "Not Available",
        "Avails": 327678920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Chinese",
        "Publisher": "AsAmNews",
        "URL": "asamnews.com",
        "App": "Not Available",
        "Avails": 255510000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Chinese",
        "Publisher": "Hyphen Magazine",
        "URL": "hyphenmagazine.com",
        "App": "Not Available",
        "Avails": 233920320.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Chinese",
        "Publisher": "Character Media",
        "URL": "charactermedia.com",
        "App": "Not Available",
        "Avails": 211023240.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Chinese",
        "Publisher": "The Epoch Times Association",
        "URL": "epochtimes.com",
        "App": "Not Available",
        "Avails": 204198000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Chinese",
        "Publisher": "World Journal",
        "URL": "worldjournal.com",
        "App": "Not Available",
        "Avails": 160666520.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Indian",
        "Publisher": "India Currents",
        "URL": "indiacurrents.com",
        "App": "Not Available",
        "Avails": 159648560.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Indian",
        "Publisher": "Khabar",
        "URL": "khabar.com",
        "App": "Not Available",
        "Avails": 155338920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Indian",
        "Publisher": "IndiaWest",
        "URL": "indiawest.com",
        "App": "Not Available",
        "Avails": 154280280.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Indian",
        "Publisher": "The American Bazaar",
        "URL": "americanbazaaronline.com",
        "App": "Not Available",
        "Avails": 142471920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Indian",
        "Publisher": "NRI Pulse",
        "URL": "nripulse.com",
        "App": "Not Available",
        "Avails": 141216080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Indian",
        "Publisher": "Desh-Videsh Media Group",
        "URL": "deshvidesh.com",
        "App": "Not Available",
        "Avails": 140962880.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Indian",
        "Publisher": "New India Abroad",
        "URL": "newindiaabroad.com",
        "App": "Not Available",
        "Avails": 138780520.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Indian",
        "Publisher": "Rediff on the Net",
        "URL": "rediff.com",
        "App": "Not Available",
        "Avails": 137910400.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Indian",
        "Publisher": "Little India",
        "URL": "littleindia.com",
        "App": "Not Available",
        "Avails": 124365600.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Ethnicity",
        "Category": "Asian Indian",
        "Publisher": "India Journal",
        "URL": "indiajournal.com",
        "App": "Not Available",
        "Avails": 123719280.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "75k-120k",
        "Publisher": "NBCUniversal",
        "URL": "cnbc.com",
        "App": "com.nbcuni.cnbc.cnbcrtipad",
        "Avails": 122823040.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "75k-120k",
        "Publisher": "The Washington Post Company",
        "URL": "washingtonpost.com",
        "App": "com.washingtonpost.wp",
        "Avails": 120439480.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "75k-120k",
        "Publisher": "Dow Jones & Company",
        "URL": "wsj.com",
        "App": "com.dowjones.WSJ.ipad",
        "Avails": 117032320.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "75k-120k",
        "Publisher": "Cond\u00e9 Nast",
        "URL": "vanityfair.com",
        "App": "com.condenast.vfmobile",
        "Avails": 112626840.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "75k-120k",
        "Publisher": "Meredith Corporation",
        "URL": "people.com",
        "App": "com.timeinc.people",
        "Avails": 111973520.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "75k-120k",
        "Publisher": "Bloomberg L.P.",
        "URL": "bloomberg.com",
        "App": "com.bloomberg.Bloomberg",
        "Avails": 111434360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "75k-120k",
        "Publisher": "Forbes Media LLC",
        "URL": "forbes.com",
        "App": "com.forbes.forbes",
        "Avails": 107094560.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "75k-120k",
        "Publisher": "Hearst Communications",
        "URL": "esquire.com",
        "App": "com.hearst.esquire",
        "Avails": 105648240.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "75k-120k",
        "Publisher": "The Atlantic Monthly Group",
        "URL": "theatlantic.com",
        "App": "com.theatlantic.TheAtlantic",
        "Avails": 102878280.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "75k-120k",
        "Publisher": "The Economist Group",
        "URL": "economist.com",
        "App": "com.economist.lamarr",
        "Avails": 99898720.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "120k+",
        "Publisher": "LuxuryAbode",
        "URL": "luxuryabode.com",
        "App": "Not Available",
        "Avails": 97255480.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "120k+",
        "Publisher": "The Luxury Spot",
        "URL": "theluxuryspot.com",
        "App": "Not Available",
        "Avails": 95957320.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "120k+",
        "Publisher": "Luxurious Magazine",
        "URL": "luxuriousmagazine.com",
        "App": "Not Available",
        "Avails": 95780040.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "120k+",
        "Publisher": "Luxury Boutique Magazine",
        "URL": "luxuryboutiquemagazine.com",
        "App": "Not Available",
        "Avails": 93157760.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "120k+",
        "Publisher": "The Rake",
        "URL": "therake.com",
        "App": "Not Available",
        "Avails": 93105040.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "120k+",
        "Publisher": "Habitually Chic",
        "URL": "habituallychic.luxury",
        "App": "Not Available",
        "Avails": 93074000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "120k+",
        "Publisher": "HiConsumption",
        "URL": "hiconsumption.com",
        "App": "Not Available",
        "Avails": 86025800.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "120k+",
        "Publisher": "How To Spend It (Financial Times)",
        "URL": "howtospendit.ft.com",
        "App": "Not Available",
        "Avails": 84465240.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "120k+",
        "Publisher": "Italia Living",
        "URL": "italialiving.com",
        "App": "Not Available",
        "Avails": 84336080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "HHI",
        "Category": "120k+",
        "Publisher": "JustLuxe",
        "URL": "justluxe.com",
        "App": "Not Available",
        "Avails": 83261720.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Women Shoppers",
        "Publisher": "Bloomberg",
        "URL": "https://www.bloomberg.com",
        "App": NaN,
        "Avails": 83087280.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Women Shoppers",
        "Publisher": "Politico",
        "URL": "https://www.politico.com",
        "App": NaN,
        "Avails": 61460440.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Women Shoppers",
        "Publisher": "CBS",
        "URL": "https://www.cbs.com",
        "App": NaN,
        "Avails": 60277120.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Women Shoppers",
        "Publisher": "Washington Post",
        "URL": "https://www.washingtonpost.com",
        "App": NaN,
        "Avails": 59174760.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Women Shoppers",
        "Publisher": "ABC",
        "URL": "https://abc.com",
        "App": NaN,
        "Avails": 59046720.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Women Shoppers",
        "Publisher": "CNN ",
        "URL": "https://edition.cnn.com",
        "App": NaN,
        "Avails": 58474040.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Women Shoppers",
        "Publisher": "Fox News",
        "URL": "https://www.foxnews.com",
        "App": NaN,
        "Avails": 58299080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Women Shoppers",
        "Publisher": "USA Today",
        "URL": "https://www.usatoday.com",
        "App": NaN,
        "Avails": 75410760.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Women Shoppers",
        "Publisher": "NBC News",
        "URL": "https://www.nbcnews.com",
        "App": NaN,
        "Avails": 72155040.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Women Shoppers",
        "Publisher": "The New York Times",
        "URL": "https://www.nytimes.com",
        "App": NaN,
        "Avails": 67690080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Black Friday",
        "Publisher": "Reuters",
        "URL": "https://www.reuters.com",
        "App": NaN,
        "Avails": 66309120.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Black Friday",
        "Publisher": "MSNBC",
        "URL": "https://www.msnbc.com",
        "App": NaN,
        "Avails": 64292360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Black Friday",
        "Publisher": "BuzzFeed",
        "URL": "https://www.buzzfeednews.com",
        "App": NaN,
        "Avails": 63228000.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Black Friday",
        "Publisher": "HuffPost",
        "URL": "https://www.huffpost.com",
        "App": NaN,
        "Avails": 61627120.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Black Friday",
        "Publisher": "Politico",
        "URL": "https://www.politico.com",
        "App": NaN,
        "Avails": 61460440.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Black Friday",
        "Publisher": "CBS",
        "URL": "https://www.cbs.com",
        "App": NaN,
        "Avails": 60277120.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Black Friday",
        "Publisher": "Washington Post",
        "URL": "https://www.washingtonpost.com",
        "App": NaN,
        "Avails": 59174760.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Black Friday",
        "Publisher": "ABC",
        "URL": "https://abc.com",
        "App": NaN,
        "Avails": 59046720.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Black Friday",
        "Publisher": "CNN ",
        "URL": "https://edition.cnn.com",
        "App": NaN,
        "Avails": 58474040.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Shopping",
        "Category": "Black Friday",
        "Publisher": "Fox News",
        "URL": "https://www.foxnews.com",
        "App": NaN,
        "Avails": 58299080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Travel",
        "Category": "Travel Enthusiast",
        "Publisher": "Lonely Travel",
        "URL": "airbnb.com",
        "App": "com.airbnb.app",
        "Avails": 58290760.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Travel",
        "Category": "Travel Enthusiast",
        "Publisher": "TripAdvisor",
        "URL": "tripadvisor.com",
        "App": "com.tripadvisor.tripadvisor",
        "Avails": 58093120.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Travel",
        "Category": "Travel Enthusiast",
        "Publisher": "Expedia",
        "URL": "expedia.com",
        "App": "com.expedia.booking",
        "Avails": 56763840.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Travel",
        "Category": "Travel Enthusiast",
        "Publisher": "Kayak",
        "URL": "kayak.com",
        "App": "com.kayak.travel",
        "Avails": 52544840.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Travel",
        "Category": "Travel Enthusiast",
        "Publisher": "Booking.com",
        "URL": "booking.com",
        "App": "com.booking.BookingTouch",
        "Avails": 51044560.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Travel",
        "Category": "Travel Enthusiast",
        "Publisher": "Travelocity",
        "URL": "travelocity.com",
        "App": "com.travelocity.travelocity",
        "Avails": 50633760.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Travel",
        "Category": "Travel Enthusiast",
        "Publisher": "The Points Guy",
        "URL": "thepointsguy.com",
        "App": "com.redventures.ThePointsGuy",
        "Avails": 50033680.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Travel",
        "Category": "Travel Enthusiast",
        "Publisher": "Skyscanner",
        "URL": "skyscanner.com",
        "App": "net.skyscanner.skyscanner",
        "Avails": 49976160.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Travel",
        "Category": "Travel Enthusiast",
        "Publisher": "Nomadic Matt",
        "URL": "nomadicmatt.com",
        "App": "Not Available",
        "Avails": 49054920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Travel",
        "Category": "Travel Enthusiast",
        "Publisher": "Lonely Planet",
        "URL": "lonelyplanet.com",
        "App": "com.lonelyplanet.guides",
        "Avails": 48907880.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "EV & Sustainable Car Buyers",
        "Publisher": "Electrek",
        "URL": "electrek.co",
        "App": "Not Available",
        "Avails": 48784440.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "EV & Sustainable Car Buyers",
        "Publisher": "InsideEVs",
        "URL": "insideevs.com",
        "App": "Not Available",
        "Avails": 48108840.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "EV & Sustainable Car Buyers",
        "Publisher": "Green Car Reports",
        "URL": "greencarreports.com",
        "App": "Not Available",
        "Avails": 47024920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "EV & Sustainable Car Buyers",
        "Publisher": "Electric Vehicle Forums",
        "URL": "electricvehicleforums.com",
        "App": "Not Available",
        "Avails": 45572040.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "EV & Sustainable Car Buyers",
        "Publisher": "Speak EV",
        "URL": "speakev.com",
        "App": "Not Available",
        "Avails": 45467720.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "EV & Sustainable Car Buyers",
        "Publisher": "Electrifying.com",
        "URL": "electrifying.com",
        "App": "Not Available",
        "Avails": 43027800.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "EV & Sustainable Car Buyers",
        "Publisher": "GreenCars",
        "URL": "greencars.com",
        "App": "Not Available",
        "Avails": 42778160.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "EV & Sustainable Car Buyers",
        "Publisher": "DIY Electric Car Forums",
        "URL": "diyelectriccar.com/forums",
        "App": "Not Available",
        "Avails": 40917520.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "EV & Sustainable Car Buyers",
        "Publisher": "Car and Driver",
        "URL": "caranddriver.com",
        "App": "com.hdm.caranddriver",
        "Avails": 40358520.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "EV & Sustainable Car Buyers",
        "Publisher": "Reddit EV Community",
        "URL": "reddit.com/r/electricvehicles",
        "App": "Not Available",
        "Avails": 40255600.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Automobile Generic",
        "Publisher": "Auto Express",
        "URL": "autoexpress.co.uk",
        "App": "Not Available",
        "Avails": 40073360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Automobile Generic",
        "Publisher": "MotorTrend",
        "URL": "motortrend.com",
        "App": "com.maz.combo1101",
        "Avails": 39128520.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Automobile Generic",
        "Publisher": "Edmunds",
        "URL": "edmunds.com",
        "App": "com.edmunds.android.edmunds",
        "Avails": 38977600.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Automobile Generic",
        "Publisher": "Hemmings",
        "URL": "hemmings.com",
        "App": "com.hemmings.HemmingsNewsstand",
        "Avails": 38346200.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Automobile Generic",
        "Publisher": "Autoweek",
        "URL": "autoweek.com",
        "App": "Not Available",
        "Avails": 37473920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Automobile Generic",
        "Publisher": "The Drive",
        "URL": "thedrive.com",
        "App": "Not Available",
        "Avails": 37194760.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Automobile Generic",
        "Publisher": "U.S. News Best Cars",
        "URL": "cars.usnews.com",
        "App": "Not Available",
        "Avails": 36095680.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Automobile Generic",
        "Publisher": "Cars.com",
        "URL": "cars.com",
        "App": "com.cars.android",
        "Avails": 35521080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Automobile Generic",
        "Publisher": "Kelley Blue Book",
        "URL": "kbb.com",
        "App": "com.kbb.mobile",
        "Avails": 34776240.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Automobile Generic",
        "Publisher": "J.D. Power",
        "URL": "jdpower.com",
        "App": "Not Available",
        "Avails": 34747720.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Luxury Car Buyers",
        "Publisher": "duPont REGISTRY",
        "URL": "dupontregistry.com",
        "App": "Not Available",
        "Avails": 34692080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Luxury Car Buyers",
        "Publisher": "Motor Authority",
        "URL": "motorauthority.com",
        "App": "Not Available",
        "Avails": 34660960.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Luxury Car Buyers",
        "Publisher": "CarGurus - Exotic",
        "URL": "cargurus.com",
        "App": "com.cargurus.mobileapp",
        "Avails": 34063640.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Luxury Car Buyers",
        "Publisher": "6SpeedOnline",
        "URL": "6speedonline.com",
        "App": "Not Available",
        "Avails": 33698960.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Luxury Car Buyers",
        "Publisher": "Luxury4Play",
        "URL": "luxury4play.com",
        "App": "Not Available",
        "Avails": 33667280.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Luxury Car Buyers",
        "Publisher": "Cars.com",
        "URL": "cars.com/research/luxury",
        "App": "com.cars.android",
        "Avails": 33606040.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Luxury Car Buyers",
        "Publisher": "Top Gear",
        "URL": "topgear.com",
        "App": "Not Available",
        "Avails": 33123360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Luxury Car Buyers",
        "Publisher": "U.S. News Best Cars",
        "URL": "cars.usnews.com",
        "App": "Not Available",
        "Avails": 31976440.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Luxury Car Buyers",
        "Publisher": "Luxuo",
        "URL": "luxuo.com",
        "App": "Not Available",
        "Avails": 31607760.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Auto Enthusiasts",
        "Category": "Luxury Car Buyers",
        "Publisher": "Rennlist",
        "URL": "rennlist.com",
        "App": "Not Available",
        "Avails": 31261760.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "MLB",
        "Publisher": "Fox Sports",
        "URL": "https://www.foxsports.com",
        "App": NaN,
        "Avails": 30238160.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "MLB",
        "Publisher": "ESPN MLB",
        "URL": "espn.com/mlb",
        "App": "com.espn.score_center",
        "Avails": 30193920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "MLB",
        "Publisher": "CBS Sports MLB",
        "URL": "cbssports.com/mlb",
        "App": "com.cbs.sportsapp",
        "Avails": 29987640.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "MLB",
        "Publisher": "Bleacher Report MLB",
        "URL": "bleacherreport.com/mlb",
        "App": "com.bleacherreport.TeamStream",
        "Avails": 29734360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "MLB",
        "Publisher": "FanGraphs",
        "URL": "fangraphs.com",
        "App": "Not Available",
        "Avails": 29590480.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "MLB",
        "Publisher": "The Athletic MLB",
        "URL": "theathletic.com/mlb",
        "App": "com.theathletic",
        "Avails": 28829640.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "MLB",
        "Publisher": "MLB Trade Rumors",
        "URL": "mlbtraderumors.com",
        "App": "Not Available",
        "Avails": 28658040.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "MLB",
        "Publisher": "Yahoo Sports MLB",
        "URL": "sports.yahoo.com/mlb",
        "App": "com.yahoo.mobile.client.android.sportacular",
        "Avails": 28288160.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "MLB",
        "Publisher": "Sporting News MLB",
        "URL": "sportingnews.com/mlb",
        "App": "Not Available",
        "Avails": 27674120.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "MLB",
        "Publisher": "Baseball-Reference",
        "URL": "baseball-reference.com",
        "App": "Not Available",
        "Avails": 27074600.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Fantasy Sports & Sports Betters",
        "Publisher": "FanDuel",
        "URL": "fanduel.com",
        "App": "com.fanduel.sportsbook",
        "Avails": 26652920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Fantasy Sports & Sports Betters",
        "Publisher": "DraftKings",
        "URL": "draftkings.com",
        "App": "com.draftkings.dknj",
        "Avails": 26312400.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Fantasy Sports & Sports Betters",
        "Publisher": "ESPN Fantasy Sports",
        "URL": "espn.com/fantasy",
        "App": "com.espn.fantasy",
        "Avails": 25798160.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Fantasy Sports & Sports Betters",
        "Publisher": "Yahoo Fantasy Sports",
        "URL": "sports.yahoo.com/fantasy",
        "App": "com.yahoo.fantasyapp",
        "Avails": 25666640.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Fantasy Sports & Sports Betters",
        "Publisher": "CBS Sports Fantasy",
        "URL": "cbssports.com/fantasy",
        "App": "com.cbs.sports.fantasy",
        "Avails": 25657440.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Fantasy Sports & Sports Betters",
        "Publisher": "Rotowire",
        "URL": "rotowire.com",
        "App": "Not Available",
        "Avails": 25532360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Fantasy Sports & Sports Betters",
        "Publisher": "FantasyPros",
        "URL": "fantasypros.com",
        "App": "Not Available",
        "Avails": 25515040.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Fantasy Sports & Sports Betters",
        "Publisher": "BetMGM",
        "URL": "betmgm.com",
        "App": "com.roardigital.betmgm",
        "Avails": 25447840.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Fantasy Sports & Sports Betters",
        "Publisher": "Caesars Sportsbook",
        "URL": "caesars.com/sportsbook",
        "App": "com.caesars.sportsbook",
        "Avails": 25290960.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NBA",
        "Publisher": "NBC Sports",
        "URL": "https://www.nbcsports.com",
        "App": NaN,
        "Avails": 25282240.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NBA",
        "Publisher": "ESPN NBA",
        "URL": "espn.com/nba",
        "App": "com.espn.score_center",
        "Avails": 25279560.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NBA",
        "Publisher": "CBS Sports NBA",
        "URL": "cbssports.com/nba",
        "App": "com.cbs.sportsapp",
        "Avails": 24932720.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NBA",
        "Publisher": "Bleacher Report NBA",
        "URL": "bleacherreport.com/nba",
        "App": "com.bleacherreport.TeamStream",
        "Avails": 24809360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NBA",
        "Publisher": "SB Nation NBA",
        "URL": "sbnation.com/nba",
        "App": "Not Available",
        "Avails": 24783080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NBA",
        "Publisher": "Sports Illustrated NBA",
        "URL": "si.com/nba",
        "App": "com.timeinc.si.viewer",
        "Avails": 24699080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NBA",
        "Publisher": "Yahoo Sports NBA",
        "URL": "sports.yahoo.com/nba",
        "App": "com.yahoo.mobile.client.android.sportacular",
        "Avails": 24659440.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NBA",
        "Publisher": "HoopsHype",
        "URL": "hoopshype.com",
        "App": "Not Available",
        "Avails": 24413760.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NBA",
        "Publisher": "Hoops Rumors",
        "URL": "hoopsrumors.com",
        "App": "Not Available",
        "Avails": 23930400.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NBA",
        "Publisher": "Fox Sports NBA",
        "URL": "foxsports.com/nba",
        "App": "com.foxsports.foxsportsapp",
        "Avails": 23704680.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Pickleball",
        "Publisher": "Koala Sports",
        "URL": "https://koalasports.com",
        "App": "Not Available",
        "Avails": 22749360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Pickleball",
        "Publisher": "The Pickler",
        "URL": "https://thepickler.com",
        "App": "Not Available",
        "Avails": 22441200.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Pickleball",
        "Publisher": "The Dink",
        "URL": "thedinkpickleball.com",
        "App": "Not Available",
        "Avails": 21242360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Pickleball",
        "Publisher": "Pickleball Channel",
        "URL": "pickleballchannel.com",
        "App": "Not Available",
        "Avails": 21072320.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Pickleball",
        "Publisher": "Pickleball Forums",
        "URL": "pickleballforums.com",
        "App": "Not Available",
        "Avails": 20901520.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Pickleball",
        "Publisher": "Pickleball Warehouse",
        "URL": "pickleballwarehouse.com",
        "App": "Not Available",
        "Avails": 20857960.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Pickleball",
        "Publisher": "Pickleball.com",
        "URL": "pickleball.com",
        "App": "Not Available",
        "Avails": 20608080.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Pickleball",
        "Publisher": "PPA Tour News",
        "URL": "ppatour.com/news",
        "App": "Not Available",
        "Avails": 20454280.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Pickleball",
        "Publisher": "Pickleheads",
        "URL": "pickleheads.com",
        "App": "Not Available",
        "Avails": 20343480.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "Pickleball",
        "Publisher": "Pickleball Superstore",
        "URL": "pickleballsuperstore.com",
        "App": "Not Available",
        "Avails": 20173680.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NFL",
        "Publisher": "Fox Sports",
        "URL": "foxsports.com",
        "App": NaN,
        "Avails": 19893400.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NFL",
        "Publisher": "ESPN NFL",
        "URL": "espn.com/nfl",
        "App": "com.espn.score_center",
        "Avails": 19659360.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NFL",
        "Publisher": "CBS Sports NFL",
        "URL": "cbssports.com/nfl",
        "App": "com.cbs.sportsapp",
        "Avails": 19514720.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NFL",
        "Publisher": "Bleacher Report NFL",
        "URL": "bleacherreport.com/nfl",
        "App": "com.bleacherreport.TeamStream",
        "Avails": 19195320.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NFL",
        "Publisher": "Sports Illustrated NFL",
        "URL": "si.com/nfl",
        "App": "com.timeinc.si.viewer",
        "Avails": 19164520.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NFL",
        "Publisher": "Yahoo Sports NFL",
        "URL": "sports.yahoo.com/nfl",
        "App": "com.yahoo.mobile.client.android.sportacular",
        "Avails": 19142920.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NFL",
        "Publisher": "SB Nation NFL",
        "URL": "sbnation.com/nfl",
        "App": "Not Available",
        "Avails": 18826640.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NFL",
        "Publisher": "ProFootballTalk",
        "URL": "profootballtalk.nbcsports.com",
        "App": "com.nbcsports.apps.nbcsports",
        "Avails": 18639680.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NFL",
        "Publisher": "Reddit NFL Community",
        "URL": "reddit.com/r/nfl",
        "App": "Not Available",
        "Avails": 18525480.0
    },
    {
        "Geo": "US",
        "Audience Segment": "Sports & Gaming Fans",
        "Category": "NFL",
        "Publisher": "Yardbarker NFL",
        "URL": "yardbarker.com/nfl",
        "App": "Not Available",
        "Avails": 18391960.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Supercar & Exotic Car Buyers",
        "Publisher": "Exotic Cars Dubai",
        "URL": "exoticcars.ae",
        "App": "Not Available",
        "Avails": 18177000.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Supercar & Exotic Car Buyers",
        "Publisher": "F1rst Motors",
        "URL": "f1rstmotors.com",
        "App": "Not Available",
        "Avails": 18152520.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Supercar & Exotic Car Buyers",
        "Publisher": "VIP Motors",
        "URL": "vipmotors.ae",
        "App": "Not Available",
        "Avails": 17964400.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Supercar & Exotic Car Buyers",
        "Publisher": "Seven Car Lounge",
        "URL": "sevencarlounge.com",
        "App": "Not Available",
        "Avails": 17962240.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Supercar & Exotic Car Buyers",
        "Publisher": "Montana Motors Bahrain",
        "URL": "montanamotors.com",
        "App": "Not Available",
        "Avails": 17829200.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Supercar & Exotic Car Buyers",
        "Publisher": "Exotic Cars Bahrain",
        "URL": "exoticcarsbahrain.com",
        "App": "Not Available",
        "Avails": 17820440.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Supercar & Exotic Car Buyers",
        "Publisher": "Bavaria Motors",
        "URL": "bavariamotors.co",
        "App": "Not Available",
        "Avails": 17706960.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Supercar & Exotic Car Buyers",
        "Publisher": "Exotic Cars Qatar",
        "URL": "exoticcarsqatar.com",
        "App": "Not Available",
        "Avails": 17191800.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Supercar & Exotic Car Buyers",
        "Publisher": "AutoTrader GCC",
        "URL": "autotradergcc.com",
        "App": "Not Available",
        "Avails": 17188560.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Luxury Brand Shoppers",
        "Publisher": "Savoir Flair",
        "URL": "https://www.savoirflair.com",
        "App": "Not Available",
        "Avails": 16756600.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Luxury Brand Shoppers",
        "Publisher": "Harper's Bazar Arabia",
        "URL": "https://www.harpersbazaararabia.com",
        "App": "Not Available",
        "Avails": 16533640.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Luxury Brand Shoppers",
        "Publisher": "Esquire Middle East",
        "URL": "https://www.esquireme.com",
        "App": "Not Available",
        "Avails": 15977960.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Luxury Brand Shoppers",
        "Publisher": "GQ Middle East",
        "URL": "https://www.gqmiddleeast.com",
        "App": "Not Available",
        "Avails": 15907320.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Luxury Brand Shoppers",
        "Publisher": "Grazia Middle East",
        "URL": "https://graziamagazine.com/me/",
        "App": "Not Available",
        "Avails": 15885720.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Luxury Brand Shoppers",
        "Publisher": "Cosmopolitan Middle East",
        "URL": "https://www.cosmopolitanme.com",
        "App": "Not Available",
        "Avails": 15845000.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Luxury Brand Shoppers",
        "Publisher": "Time Out GCC",
        "URL": "https://www.timeoutdubai.com",
        "App": "Not Available",
        "Avails": 15841360.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Luxury Brand Shoppers",
        "Publisher": "Lovin Dubai",
        "URL": "https://lovin.co/dubai",
        "App": "Not Available",
        "Avails": 15344560.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Luxury Brand Shoppers",
        "Publisher": "Smashi",
        "URL": "https://smashi.tv/en",
        "App": "Not Available",
        "Avails": 15335040.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Luxury Brand Shoppers",
        "Publisher": "What's On",
        "URL": "https://whatson.ae",
        "App": "Not Available",
        "Avails": 15031280.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Elite Travel Enthusiasts ",
        "Publisher": "ITL World",
        "URL": "itlworld.com",
        "App": "Not Available",
        "Avails": 15014520.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Elite Travel Enthusiasts ",
        "Publisher": "Unique Family Travels",
        "URL": "uniquefamilytravels.com",
        "App": "Not Available",
        "Avails": 14783960.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Elite Travel Enthusiasts ",
        "Publisher": "One Concierge",
        "URL": "oneconcierge.com",
        "App": "Not Available",
        "Avails": 14594760.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Elite Travel Enthusiasts ",
        "Publisher": "Priv\u00e9 Travel Concierge",
        "URL": "privetravelconcierge.com",
        "App": "Not Available",
        "Avails": 14499160.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Elite Travel Enthusiasts ",
        "Publisher": "The Billionaire Concierge",
        "URL": "thebillionaireconcierge.com",
        "App": "Not Available",
        "Avails": 14364000.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Elite Travel Enthusiasts ",
        "Publisher": "Quintessentially",
        "URL": "quintessentially.com",
        "App": "Not Available",
        "Avails": 14035080.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Elite Travel Enthusiasts ",
        "Publisher": "Elite Travel & Tourism",
        "URL": "elitetourism.com",
        "App": "Not Available",
        "Avails": 13869240.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Elite Travel Enthusiasts ",
        "Publisher": "Elite Voyages",
        "URL": "elitevoyages.com",
        "App": "Not Available",
        "Avails": 13867080.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Elite Travel Enthusiasts ",
        "Publisher": "Elite Travel",
        "URL": "elitetravel.co",
        "App": "Not Available",
        "Avails": 13769840.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Elite Travel Enthusiasts ",
        "Publisher": "Elite Global Journeys",
        "URL": "eliteglobaljourneys.com",
        "App": "Not Available",
        "Avails": 13768760.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Food",
        "Publisher": "Talabat",
        "URL": "talabat.com",
        "App": "com.talabat.TalabatApp",
        "Avails": 13722600.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Food",
        "Publisher": "Deliveroo",
        "URL": "deliveroo.ae",
        "App": "com.deliveroo.orderapp",
        "Avails": 13552200.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Food",
        "Publisher": "PR Newswire",
        "URL": "prnewswire.com",
        "App": "Not Available",
        "Avails": 13524800.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Food",
        "Publisher": "Simply Recipes",
        "URL": "simplyrecipes.com",
        "App": "Not Available",
        "Avails": 13442480.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Food",
        "Publisher": "Food & Wine",
        "URL": "foodandwine.com",
        "App": "Not Available",
        "Avails": 13378760.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Food",
        "Publisher": "Allrecipes",
        "URL": "allrecipes.com",
        "App": "Not Available",
        "Avails": 13313400.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Food",
        "Publisher": "Yahoo Finance",
        "URL": "finance.yahoo.com",
        "App": "Not Available",
        "Avails": 13303120.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Food",
        "Publisher": "Reuters",
        "URL": "reuters.com",
        "App": "Not Available",
        "Avails": 13263840.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Food",
        "Publisher": "Green Kitchen Stories",
        "URL": "greenkitchenstories.com",
        "App": "Not Available",
        "Avails": 13225920.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Luxury & High-Net-Worth Individuals (HNWIs)",
        "Category": "Food",
        "Publisher": "Hospitality News Magazine",
        "URL": "hospitalitynewsmag.com",
        "App": "Not Available",
        "Avails": 13106480.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Western Expats",
        "Publisher": "InterNations",
        "URL": "internations.org",
        "App": "com.internations.app",
        "Avails": 12985080.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Western Expats",
        "Publisher": "ExpatWoman",
        "URL": "expatwoman.com",
        "App": "Not Available",
        "Avails": 12903520.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Western Expats",
        "Publisher": "Expat.com",
        "URL": "expat.com",
        "App": "com.expatdotcom.expat",
        "Avails": 12681320.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Western Expats",
        "Publisher": "Expat Exchange",
        "URL": "expatexchange.com",
        "App": "Not Available",
        "Avails": 12599240.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Western Expats",
        "Publisher": "Meetup",
        "URL": "meetup.com",
        "App": "com.meetup.Meetup",
        "Avails": 12569320.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Western Expats",
        "Publisher": "Time Out Dubai",
        "URL": "timeoutdubai.com",
        "App": "com.timeoutdubai.ios",
        "Avails": 12522280.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Western Expats",
        "Publisher": "Expat Forum",
        "URL": "expatforum.com",
        "App": "Not Available",
        "Avails": 12504440.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Western Expats",
        "Publisher": "Arabian Business",
        "URL": "arabianbusiness.com",
        "App": "Not Available",
        "Avails": 12415000.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Western Expats",
        "Publisher": "The National UAE",
        "URL": "thenationalnews.com",
        "App": "com.thenational.news",
        "Avails": 12410080.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Western Expats",
        "Publisher": "Khaleej Times",
        "URL": "khaleejtimes.com",
        "App": "com.khaleejtimes.app",
        "Avails": 12390520.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Asian & Chinese Expats",
        "Publisher": "InterNations",
        "URL": "internations.org",
        "App": "com.internations.app",
        "Avails": 12342040.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Asian & Chinese Expats",
        "Publisher": "Expat.com",
        "URL": "expat.com",
        "App": "com.expatdotcom.expat",
        "Avails": 12306040.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Asian & Chinese Expats",
        "Publisher": "Meetup",
        "URL": "meetup.com",
        "App": "com.meetup.Meetup",
        "Avails": 12192840.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Asian & Chinese Expats",
        "Publisher": "Expat Forum",
        "URL": "expatforum.com",
        "App": "Not Available",
        "Avails": 12174360.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Asian & Chinese Expats",
        "Publisher": "The Beijinger",
        "URL": "thebeijinger.com",
        "App": "Not Available",
        "Avails": 12161000.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Asian & Chinese Expats",
        "Publisher": "Arabian Business",
        "URL": "arabianbusiness.com",
        "App": "com.arabianbusiness.abnews",
        "Avails": 12067720.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Asian & Chinese Expats",
        "Publisher": "China Daily",
        "URL": "chinadaily.com.cn",
        "App": "cn.com.chinadaily.iPaper",
        "Avails": 12067040.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Asian & Chinese Expats",
        "Publisher": "Time Out Dubai",
        "URL": "timeoutdubai.com",
        "App": "com.timeout.timeoutdubai",
        "Avails": 12049560.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Asian & Chinese Expats",
        "Publisher": "Gulf News",
        "URL": "gulfnews.com",
        "App": "com.gulfnews.gulfnews",
        "Avails": 12046960.0
    },
    {
        "Geo": "GCC",
        "Audience Segment": "Multicultural & Expat Communities",
        "Category": "Asian & Chinese Expats",
        "Publisher": "The National",
        "URL": "thenationalnews.com",
        "App": "com.thenational.thenational",
        "Avails": 12034960.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "E-Commerce & Online Shopping Consumers",
        "Category": "Luxury Brand Buyers ",
        "Publisher": "Pop Bela",
        "URL": "https://www.popbela.com",
        "App": NaN,
        "Avails": 11990680.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "E-Commerce & Online Shopping Consumers",
        "Category": "Luxury Brand Buyers ",
        "Publisher": "Dream.co.id",
        "URL": "Dream.co.id",
        "App": NaN,
        "Avails": 11938040.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "E-Commerce & Online Shopping Consumers",
        "Category": "Luxury Brand Buyers ",
        "Publisher": "Wolipop",
        "URL": "https://wolipop.detik.com",
        "App": NaN,
        "Avails": 11867440.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "E-Commerce & Online Shopping Consumers",
        "Category": "Luxury Brand Buyers ",
        "Publisher": "Femina",
        "URL": "https://femina.co.id",
        "App": NaN,
        "Avails": 11811080.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "E-Commerce & Online Shopping Consumers",
        "Category": "Luxury Brand Buyers ",
        "Publisher": "Fimela.com",
        "URL": "https://www.fimela.com",
        "App": NaN,
        "Avails": 11744440.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "E-Commerce & Online Shopping Consumers",
        "Category": "Luxury Brand Buyers ",
        "Publisher": "Hipwee",
        "URL": "https://www.hipwee.com",
        "App": NaN,
        "Avails": 11708720.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "E-Commerce & Online Shopping Consumers",
        "Category": "Luxury Brand Buyers ",
        "Publisher": "Kincir",
        "URL": "https://kincir.com",
        "App": NaN,
        "Avails": 11692080.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "E-Commerce & Online Shopping Consumers",
        "Category": "Luxury Brand Buyers ",
        "Publisher": "MalesBanget.com",
        "URL": "MalesBanget.com",
        "App": NaN,
        "Avails": 11686880.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "E-Commerce & Online Shopping Consumers",
        "Category": "Luxury Brand Buyers ",
        "Publisher": "Brilio.net",
        "URL": "Brilio.net",
        "App": NaN,
        "Avails": 11668160.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "E-Commerce & Online Shopping Consumers",
        "Category": "Luxury Brand Buyers ",
        "Publisher": "What's New Indonesia",
        "URL": "https://whatsnewindonesia.com",
        "App": NaN,
        "Avails": 11643840.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "K-Drama & K-Pop Fans",
        "Publisher": "Viki",
        "URL": "viki.com",
        "App": "com.viki.vikiapp",
        "Avails": 11641160.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "K-Drama & K-Pop Fans",
        "Publisher": "iQIYI",
        "URL": "iq.com",
        "App": "com.iqiyi.iQiyiVideo",
        "Avails": 11636200.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "K-Drama & K-Pop Fans",
        "Publisher": "WeTV",
        "URL": "wetv.vip/en",
        "App": "com.tencent.qqlivei18n",
        "Avails": 11591720.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "K-Drama & K-Pop Fans",
        "Publisher": "KBS World",
        "URL": "world.kbs.co.kr",
        "App": "Not Available",
        "Avails": 11551520.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "K-Drama & K-Pop Fans",
        "Publisher": "allkpop",
        "URL": "allkpop.com",
        "App": "Not Available",
        "Avails": 11515200.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "K-Drama & K-Pop Fans",
        "Publisher": "Soompi",
        "URL": "soompi.com",
        "App": "Not Available",
        "Avails": 11459880.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "K-Drama & K-Pop Fans",
        "Publisher": "Koreaboo",
        "URL": "koreaboo.com",
        "App": "Not Available",
        "Avails": 11381560.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "K-Drama & K-Pop Fans",
        "Publisher": "Weverse",
        "URL": "weverse.io",
        "App": "com.weverse.app",
        "Avails": 11369080.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "K-Drama & K-Pop Fans",
        "Publisher": "KOCOWA",
        "URL": "kocowa.com",
        "App": "com.kcpglobal.kocowa",
        "Avails": 11346160.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "K-Drama & K-Pop Fans",
        "Publisher": "MyDramaList",
        "URL": "mydramalist.com",
        "App": "Not Available",
        "Avails": 11142000.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High CTR",
        "Publisher": "Times Internet Limited (TIL)",
        "URL": "https://timesinternet.in",
        "App": NaN,
        "Avails": 4308906789.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High CTR",
        "Publisher": "Network18 Group",
        "URL": "https://www.nw18.com",
        "App": NaN,
        "Avails": 3564567894.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High CTR",
        "Publisher": "Zee Digital",
        "URL": "https://zeenews.india.com/tags/zee-digital.html",
        "App": NaN,
        "Avails": 2549809034.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High CTR",
        "Publisher": "India Today Group",
        "URL": "https://www.indiatoday.in",
        "App": NaN,
        "Avails": 2035670078.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High CTR",
        "Publisher": "The Indian Express",
        "URL": "https://indianexpress.com",
        "App": NaN,
        "Avails": 1767832011.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High CTR",
        "Publisher": "NDTV",
        "URL": "https://www.ndtv.com",
        "App": NaN,
        "Avails": 1326789560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High CTR",
        "Publisher": "The Hindu",
        "URL": "https://www.thehindu.com",
        "App": NaN,
        "Avails": 465903489.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High CTR",
        "Publisher": "Hindustan Times Digital",
        "URL": "https://www.hindustantimes.com",
        "App": NaN,
        "Avails": 406789432.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High CTR",
        "Publisher": "Dainik Bhaskar",
        "URL": "https://www.bhaskar.com",
        "App": NaN,
        "Avails": 1897905482.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High CTR",
        "Publisher": "Amar Ujala",
        "URL": "https://www.amarujala.com",
        "App": NaN,
        "Avails": 1438678905.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High Viewability",
        "Publisher": "Times Of India",
        "URL": "https://timesofindia.indiatimes.com",
        "App": NaN,
        "Avails": 3658948670.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High Viewability",
        "Publisher": "Dainik Jagran",
        "URL": "https://www.jagran.com",
        "App": NaN,
        "Avails": 1897905482.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High Viewability",
        "Publisher": "Quint",
        "URL": "https://www.thequint.com",
        "App": NaN,
        "Avails": 486734782.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High Viewability",
        "Publisher": "Digit",
        "URL": "https://www.digit.in",
        "App": NaN,
        "Avails": 176582309.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High Viewability",
        "Publisher": "Magzter",
        "URL": "https://www.magzter.com/en/",
        "App": NaN,
        "Avails": 164680267.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High Viewability",
        "Publisher": "NDTV",
        "URL": "https://www.ndtv.com",
        "App": NaN,
        "Avails": 1326789560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High Viewability",
        "Publisher": "India Today",
        "URL": "https://www.indiatoday.in",
        "App": NaN,
        "Avails": 2035670078.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High Viewability",
        "Publisher": "Inshorts",
        "URL": "https://inshorts.com",
        "App": NaN,
        "Avails": 104340378.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High Viewability",
        "Publisher": "Network 18",
        "URL": "https://www.nw18.com",
        "App": NaN,
        "Avails": 3564567894.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High Viewability",
        "Publisher": "Times Internet Limited ",
        "URL": "https://timesinternet.in",
        "App": NaN,
        "Avails": 4308906789.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High VCR",
        "Publisher": "T-Series",
        "URL": "https://www.tseries.com",
        "App": NaN,
        "Avails": 109859420.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High VCR",
        "Publisher": "NDTV",
        "URL": "https://www.ndtv.com",
        "App": NaN,
        "Avails": 1326789560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High VCR",
        "Publisher": "India Today Group",
        "URL": "https://www.indiatoday.in",
        "App": NaN,
        "Avails": 2035670078.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High VCR",
        "Publisher": "The Times of India",
        "URL": "https://timesofindia.indiatimes.com",
        "App": NaN,
        "Avails": 3658948670.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High VCR",
        "Publisher": "Hindustan Times",
        "URL": "https://www.hindustantimes.com",
        "App": NaN,
        "Avails": 406789432.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High VCR",
        "Publisher": "The Indian Express",
        "URL": "https://indianexpress.com",
        "App": NaN,
        "Avails": 1767832011.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High VCR",
        "Publisher": "Dainik Bhaskar",
        "URL": "https://www.bhaskar.com",
        "App": NaN,
        "Avails": 1897905482.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High VCR",
        "Publisher": "Network18 Group",
        "URL": "https://www.nw18.com",
        "App": NaN,
        "Avails": 3564567894.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High VCR",
        "Publisher": "Zee Digital",
        "URL": "https://zeenews.india.com/tags/zee-digital.html",
        "App": NaN,
        "Avails": 2549809034.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Performance",
        "Category": "High VCR",
        "Publisher": "Amar Ujala",
        "URL": "https://www.amarujala.com",
        "App": NaN,
        "Avails": 1438678905.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "Ria Ricis",
        "URL": "riaricis.com",
        "App": "Not Available",
        "Avails": 11097720.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "Jess No Limit",
        "URL": "jessnolimit.com",
        "App": "Not Available",
        "Avails": 10963920.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "Agung Hapsah",
        "URL": "agunghapsah.com",
        "App": "Not Available",
        "Avails": 10948080.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "Sweet Like a Peach",
        "URL": "sweetlikeapeach.com",
        "App": "Not Available",
        "Avails": 10806480.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "Alodita",
        "URL": "alodita.com",
        "App": "Not Available",
        "Avails": 10718800.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "Marischka Prudence",
        "URL": "marischkaprudence.com",
        "App": "Not Available",
        "Avails": 10638000.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "The Travel Junkie",
        "URL": "thetraveljunkie.com",
        "App": "Not Available",
        "Avails": 10483400.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "Hello Sasyachi",
        "URL": "hellosasyachi.com",
        "App": "Not Available",
        "Avails": 10410560.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "The Urban Mama",
        "URL": "theurbanmama.com",
        "App": "Not Available",
        "Avails": 10405400.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "Xiao Vee",
        "URL": "xiaovee.com",
        "App": "Not Available",
        "Avails": 10296240.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Entertainment & Lifestyle Consumers",
        "Category": "Influencer & Vlogger Followers",
        "Publisher": "Sisca Kohl",
        "URL": "siscakohl.com",
        "App": "Not Available",
        "Avails": 10279680.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Football Fanatics",
        "Publisher": "BolaSport",
        "URL": "bolasport.com",
        "App": "Not Available",
        "Avails": 10258560.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Football Fanatics",
        "Publisher": "BolaSkor",
        "URL": "bolaskor.com",
        "App": "org.bolaskor.app",
        "Avails": 10249360.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Football Fanatics",
        "Publisher": "Goal Indonesia",
        "URL": "goal.com/id",
        "App": "com.freerange360.Goal",
        "Avails": 10212160.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Football Fanatics",
        "Publisher": "DetikSport",
        "URL": "sport.detik.com",
        "App": "org.detikcom.rss",
        "Avails": 10017320.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Football Fanatics",
        "Publisher": "Kompas Bola",
        "URL": "bola.kompas.com",
        "App": "com.kompas.android",
        "Avails": 9959280.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Football Fanatics",
        "Publisher": "Liputan6 Bola",
        "URL": "bola.liputan6.com",
        "App": "com.kmk.liputan6",
        "Avails": 9896960.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Football Fanatics",
        "Publisher": "Okezone Bola",
        "URL": "bola.okezone.com",
        "App": "linktone.okezone",
        "Avails": 9839080.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Football Fanatics",
        "Publisher": "Viva Bola",
        "URL": "bola.viva.co.id",
        "App": "com.viva.news",
        "Avails": 9712560.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Football Fanatics",
        "Publisher": "Indosport",
        "URL": "indosport.com",
        "App": "Not Available",
        "Avails": 9680080.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Football Fanatics",
        "Publisher": "CNN Indonesia",
        "URL": "cnnindonesia.com",
        "App": "com.turner.cnnindonesia",
        "Avails": 9411000.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Badminton Enthusiasts",
        "Publisher": "Antara News",
        "URL": "antaranews.com",
        "App": "Not Available",
        "Avails": 9381080.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Badminton Enthusiasts",
        "Publisher": "Kompas.com",
        "URL": "kompas.com",
        "App": "com.kompas.android",
        "Avails": 9355080.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Badminton Enthusiasts",
        "Publisher": "Detik.com",
        "URL": "detik.com",
        "App": "org.detikcom.rss",
        "Avails": 9277920.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Badminton Enthusiasts",
        "Publisher": "Liputan6.com",
        "URL": "liputan6.com",
        "App": "com.kmk.liputan6",
        "Avails": 9230120.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Badminton Enthusiasts",
        "Publisher": "Okezone.com",
        "URL": "okezone.com",
        "App": "linktone.okezone",
        "Avails": 9228960.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Badminton Enthusiasts",
        "Publisher": "Viva.co.id",
        "URL": "viva.co.id",
        "App": "com.viva.news",
        "Avails": 9218880.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Badminton Enthusiasts",
        "Publisher": "Tribunnews.com",
        "URL": "tribunnews.com",
        "App": "com.tribun.tribunnews",
        "Avails": 9050320.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Badminton Enthusiasts",
        "Publisher": "CNN Indonesia",
        "URL": "cnnindonesia.com",
        "App": "com.turner.cnnindonesia",
        "Avails": 9041920.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Badminton Enthusiasts",
        "Publisher": "IDN Times",
        "URL": "idntimes.com",
        "App": "com.idntimes.idntimes",
        "Avails": 9020280.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Badminton Enthusiasts",
        "Publisher": "Suara.com",
        "URL": "suara.com",
        "App": "Not Available",
        "Avails": 8974480.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Cycling & Running Communities ",
        "Publisher": "Kemenparekraf (Ministry of Tourism and Creative Economy)",
        "URL": "kemenparekraf.go.id",
        "App": "Not Available",
        "Avails": 8955440.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Cycling & Running Communities ",
        "Publisher": "IndoRunners",
        "URL": "instagram.com/indorunners",
        "App": "Not Available",
        "Avails": 8926880.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Cycling & Running Communities ",
        "Publisher": "Trail Runners Indonesia",
        "URL": "facebook.com/groups/trailrunnersindonesia",
        "App": "Not Available",
        "Avails": 8784120.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Cycling & Running Communities ",
        "Publisher": "World's Marathons",
        "URL": "worldsmarathons.com",
        "App": "Not Available",
        "Avails": 8779240.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Cycling & Running Communities ",
        "Publisher": "Komoot",
        "URL": "komoot.com",
        "App": "Not Available",
        "Avails": 8776560.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Cycling & Running Communities ",
        "Publisher": "Outdooractive",
        "URL": "outdooractive.com",
        "App": "Not Available",
        "Avails": 8668240.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Cycling & Running Communities ",
        "Publisher": "Exodus Travels",
        "URL": "exodustravels.com",
        "App": "Not Available",
        "Avails": 8603720.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Cycling & Running Communities ",
        "Publisher": "Jakarta Globe",
        "URL": "jakartaglobe.id",
        "App": "Not Available",
        "Avails": 8602840.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Cycling & Running Communities ",
        "Publisher": "The Jakarta Post",
        "URL": "thejakartapost.com",
        "App": "Not Available",
        "Avails": 8595960.0
    },
    {
        "Geo": "Indonesia",
        "Audience Segment": "Sports & Fitness Fans",
        "Category": "Cycling & Running Communities ",
        "Publisher": "Fitness First Indonesia",
        "URL": "fitnessfirst.com",
        "App": "Not Available",
        "Avails": 8542440.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Hindi",
        "Publisher": "Hindi Times Media",
        "URL": "hinditimesmedia.com",
        "App": "Not Available",
        "Avails": 8540480.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Hindi",
        "Publisher": "Indo-Canadian Voice",
        "URL": "voiceonline.com",
        "App": "Not Available",
        "Avails": 8515840.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Hindi",
        "Publisher": "South Asian Daily",
        "URL": "southasiandaily.com",
        "App": "Not Available",
        "Avails": 8512840.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Hindi",
        "Publisher": "Hindu Times Canada",
        "URL": "hindutimescanada.ca",
        "App": "Not Available",
        "Avails": 8456160.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Hindi",
        "Publisher": "Connect FM 91.5",
        "URL": "connectfm.ca",
        "App": "Not Available",
        "Avails": 8412680.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Hindi",
        "Publisher": "Indo-Canadian Community Centre",
        "URL": "icccottawa.org",
        "App": "Not Available",
        "Avails": 8373280.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Hindi",
        "Publisher": "RED FM 93.1 Vancouver",
        "URL": "redfm.ca",
        "App": "Not Available",
        "Avails": 8358320.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Hindi",
        "Publisher": "RED FM 88.9 Toronto",
        "URL": "redfm.ca",
        "App": "Not Available",
        "Avails": 8350640.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Hindi",
        "Publisher": "CMR Hindi FM Radio",
        "URL": "cmr24fm.com",
        "App": "Not Available",
        "Avails": 8345040.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Hindi",
        "Publisher": "Radio India",
        "URL": "radioindialtd.com",
        "App": "Not Available",
        "Avails": 8281880.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Chinese",
        "Publisher": "Sing Tao Daily (Canada)",
        "URL": "singtao.ca",
        "App": "ca.singtao.app",
        "Avails": 8270480.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Chinese",
        "Publisher": "Fairchild Radio",
        "URL": "fairchildradio.com",
        "App": "com.fairchildradio.app",
        "Avails": 8178880.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Chinese",
        "Publisher": "OMNI Television",
        "URL": "omnitv.ca",
        "App": "Not Available",
        "Avails": 8140920.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Chinese",
        "Publisher": "Chinese Cultural Centre of Greater Vancouver",
        "URL": "cccgv.org",
        "App": "Not Available",
        "Avails": 8061280.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Chinese",
        "Publisher": "Today Commercial News",
        "URL": "tcntoday.ca",
        "App": "Not Available",
        "Avails": 8056200.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Chinese",
        "Publisher": "Chinese Canadian Times",
        "URL": "cctimes.ca",
        "App": "Not Available",
        "Avails": 7978800.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Chinese",
        "Publisher": "Chinese Cultural Centre of Greater Toronto",
        "URL": "cccgt.org",
        "App": "Not Available",
        "Avails": 7951520.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Chinese",
        "Publisher": "Ming Pao Daily News (Canada)",
        "URL": "mingpaocanada.com",
        "App": "Not Available",
        "Avails": 7918840.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Chinese",
        "Publisher": "Epoch Times (Canada)",
        "URL": "epochtimes.com/gb",
        "App": "Not Available",
        "Avails": 7910120.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Chinese",
        "Publisher": "Toronto Chinese Business Association",
        "URL": "tcbacanada.com",
        "App": "Not Available",
        "Avails": 7897120.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Arabic",
        "Publisher": "Al Wattan Newspaper",
        "URL": "alwattan.ca",
        "App": "Not Available",
        "Avails": 7889960.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Arabic",
        "Publisher": "Arab News International",
        "URL": "arabnews.ca",
        "App": "Not Available",
        "Avails": 7855520.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Arabic",
        "Publisher": "Middle East Radio - Montreal",
        "URL": "meradio.ca",
        "App": "Not Available",
        "Avails": 7781920.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Arabic",
        "Publisher": "Radio CINA",
        "URL": "radiocina.com",
        "App": "Not Available",
        "Avails": 7745640.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Arabic",
        "Publisher": "Calgary Arabia Radio",
        "URL": "radioguide.fm",
        "App": "Not Available",
        "Avails": 7659680.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Arabic",
        "Publisher": "The Arab Community Centre of Toronto",
        "URL": "acctonline.ca",
        "App": "Not Available",
        "Avails": 7647000.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Arabic",
        "Publisher": "Canadian Arab Institute",
        "URL": "canadianarabinstitute.org",
        "App": "Not Available",
        "Avails": 7614760.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Arabic",
        "Publisher": "All Arab in Canada",
        "URL": "allarabcanada.com",
        "App": "Not Available",
        "Avails": 7614400.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Arabic",
        "Publisher": "Nota Arabia Canada",
        "URL": "myradiobox.com",
        "App": "Not Available",
        "Avails": 7598760.0
    },
    {
        "Geo": "Canada",
        "Audience Segment": "Language",
        "Category": "Arabic",
        "Publisher": "Middle East Radio",
        "URL": "online-radio.eu",
        "App": "Not Available",
        "Avails": 7509920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Gen Z female beauty",
        "Publisher": "POPxo",
        "URL": "popxo.com",
        "App": "com.popxo.app",
        "Avails": 7493520.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Gen Z female beauty",
        "Publisher": "MissMalini",
        "URL": "missmalini.com",
        "App": "com.missmalini.app",
        "Avails": 7448560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Gen Z female beauty",
        "Publisher": "Femina",
        "URL": "femina.in",
        "App": "com.femina.app",
        "Avails": 7442280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Gen Z female beauty",
        "Publisher": "Skincare Villa",
        "URL": "skincarevilla.com",
        "App": "Not Available",
        "Avails": 7441720.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Gen Z female beauty",
        "Publisher": "i Diva",
        "URL": "https://www.idiva.com",
        "App": "Not Available",
        "Avails": 7404960.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Gen Z female beauty",
        "Publisher": "GirlXplorer",
        "URL": "girlxplorer.com",
        "App": "Not Available",
        "Avails": 7382200.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Gen Z female beauty",
        "Publisher": "Women Fashion Store",
        "URL": "womenfashionstore.in",
        "App": "Not Available",
        "Avails": 7374800.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Gen Z female beauty",
        "Publisher": "Beauty Duniya",
        "URL": "beautyduniya.in",
        "App": "Not Available",
        "Avails": 7328920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Gen Z female beauty",
        "Publisher": "Beauty and the Geek",
        "URL": "beautyandthegeek.online",
        "App": "Not Available",
        "Avails": 7216400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Gen Z female beauty",
        "Publisher": "GlamShe",
        "URL": "glamshe.com",
        "App": "Not Available",
        "Avails": 7202120.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Fashion",
        "Publisher": "Vogue India",
        "URL": "vogue.in",
        "App": "Not Available",
        "Avails": 7172840.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Fashion",
        "Publisher": "ELLE India",
        "URL": "elle.in",
        "App": "Not Available",
        "Avails": 7169960.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Fashion",
        "Publisher": "MissMalini",
        "URL": "missmalini.com",
        "App": "Not Available",
        "Avails": 7157920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Fashion",
        "Publisher": "Femina",
        "URL": "femina.in",
        "App": "Not Available",
        "Avails": 7148640.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Fashion",
        "Publisher": "POPxo",
        "URL": "popxo.com",
        "App": "com.popxo.app",
        "Avails": 7126080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Fashion",
        "Publisher": "Scoop Whoop",
        "URL": "https://www.scoopwhoop.com",
        "App": NaN,
        "Avails": 7108800.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Fashion",
        "Publisher": "StyleCraze",
        "URL": "https://www.stylecraze.com",
        "App": "Not Available",
        "Avails": 7052840.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Fashion",
        "Publisher": "i Diva",
        "URL": "https://www.idiva.com",
        "App": "Not Available",
        "Avails": 7051560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Fashion",
        "Publisher": "The Better India",
        "URL": "https://thebetterindia.com",
        "App": "Not Available",
        "Avails": 6955080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Fashion",
        "Publisher": "BuzzFeed",
        "URL": "https://www.buzzfeednews.com",
        "App": "Not Available",
        "Avails": 6950520.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Moms",
        "Publisher": "Momspresso",
        "URL": "www.momspresso.com",
        "App": "Not Available",
        "Avails": 6945120.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Moms",
        "Publisher": "Champa Tree",
        "URL": "www.thechampatree.in",
        "App": "Not Available",
        "Avails": 6944360.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Moms",
        "Publisher": "KidsStopPress",
        "URL": "www.kidsstoppress.com",
        "App": "Not Available",
        "Avails": 6943000.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Moms",
        "Publisher": "MyLittleMoppet",
        "URL": "https://www.mylittlemoppet.com",
        "App": "Not Available",
        "Avails": 6941320.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Moms",
        "Publisher": "Femina",
        "URL": "https://www.femina.in",
        "App": "Not Available",
        "Avails": 6916000.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Moms",
        "Publisher": "BeingTheParent",
        "URL": "https://www.beingtheparent.com",
        "App": "Not Available",
        "Avails": 6906920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Moms",
        "Publisher": "PoPXO",
        "URL": "www.popxo.com",
        "App": "Not Available",
        "Avails": 6839680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Moms",
        "Publisher": "ELLE India",
        "URL": "elle.in",
        "App": "Not Available",
        "Avails": 6820400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Moms",
        "Publisher": "ProEves",
        "URL": "https://www.proeves.com",
        "App": "Not Available",
        "Avails": 6813320.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Moms",
        "Publisher": "Vogue India",
        "URL": "vogue.in",
        "App": "Not Available",
        "Avails": 6799560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Millennial Female Fashion",
        "Publisher": "I Diva",
        "URL": "https://www.idiva.com",
        "App": NaN,
        "Avails": 6776080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Millennial Female Fashion",
        "Publisher": "Grazia",
        "URL": "https://www.grazia.co.in",
        "App": NaN,
        "Avails": 6684560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Millennial Female Fashion",
        "Publisher": "MissMalini",
        "URL": "missmalini.com",
        "App": NaN,
        "Avails": 6596360.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Millennial Female Fashion",
        "Publisher": "NDTV Good Times",
        "URL": "https://www.ndtv.com/topic/ndtv-good-times",
        "App": NaN,
        "Avails": 6577240.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Millennial Female Fashion",
        "Publisher": "Vogue India",
        "URL": "vogue.in",
        "App": "Not Available",
        "Avails": 6570920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Millennial Female Fashion",
        "Publisher": "Cosmopolitan",
        "URL": "https://www.cosmopolitan.com",
        "App": NaN,
        "Avails": 6538720.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Millennial Female Fashion",
        "Publisher": "Little Black Book",
        "URL": "https://lbbonline.com/?edition=international",
        "App": "Not Available",
        "Avails": 6508440.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Millennial Female Fashion",
        "Publisher": "Elle India",
        "URL": "elle.in",
        "App": "Not Available",
        "Avails": 6494800.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Millennial Female Fashion",
        "Publisher": "Harper's Bazaar",
        "URL": "bazaarindia.in",
        "App": "Not Available",
        "Avails": 6493920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Millennial Female Fashion",
        "Publisher": "Femina",
        "URL": "femina.in",
        "App": "Not Available",
        "Avails": 6427080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 18-25",
        "Publisher": "The Loom",
        "URL": "theloom.in",
        "App": "Not Available",
        "Avails": 6391840.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 18-25",
        "Publisher": "Vogue India",
        "URL": "vogue.in",
        "App": NaN,
        "Avails": 6385080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 18-25",
        "Publisher": "Cosmopolitan India",
        "URL": "Not Available",
        "App": "Not Available",
        "Avails": 6384960.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 18-25",
        "Publisher": "Femina",
        "URL": "femina.in",
        "App": NaN,
        "Avails": 6380000.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 18-25",
        "Publisher": "POPxo",
        "URL": "popxo.com",
        "App": NaN,
        "Avails": 6372080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 18-25",
        "Publisher": "Grazia",
        "URL": "https://www.grazia.co.in",
        "App": NaN,
        "Avails": 6329400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 18-25",
        "Publisher": "Dailyhunt",
        "URL": "dailyhunt.in",
        "App": "com.eterno",
        "Avails": 6312680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 18-25",
        "Publisher": "Inshorts",
        "URL": "inshorts.com",
        "App": "com.nis.app",
        "Avails": 6310720.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 18-25",
        "Publisher": "The Quint",
        "URL": "thequint.com",
        "App": "Not Available",
        "Avails": 6310080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 18-25",
        "Publisher": "Aaj Tak",
        "URL": "aajtak.in",
        "App": "Not Available",
        "Avails": 6309400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "The Souled Store",
        "URL": "thesouledstore.com",
        "App": "Not Available",
        "Avails": 6281000.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "Little Black Book",
        "URL": "lbb.in",
        "App": "Not Available",
        "Avails": 6269760.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "WedMeGood",
        "URL": "wedmegood.com",
        "App": "com.wedmegood.wedmegood",
        "Avails": 6268800.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "Clovia",
        "URL": "clovia.com",
        "App": "com.purplepanda.clovia",
        "Avails": 6255080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "Sheroes",
        "URL": "sheroes.com",
        "App": "Not Available",
        "Avails": 6247440.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "POPxo",
        "URL": "https://www.popxo.com",
        "App": "Not Available",
        "Avails": 6203800.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "Tweak India",
        "URL": "tweakindia.com",
        "App": "Not Available",
        "Avails": 6201320.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "Cosmopolitan",
        "URL": "cosmopolitan.com",
        "App": "Not Available",
        "Avails": 6185880.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "Dailyhunt",
        "URL": "dailyhunt.in",
        "App": NaN,
        "Avails": 6160080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "Magzter",
        "URL": "https://www.magzter.com",
        "App": NaN,
        "Avails": 6159920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 26-35",
        "Publisher": "Scoop Whoop",
        "URL": "https://www.scoopwhoop.com",
        "App": "com.myntra.android",
        "Avails": 6139800.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 36-45",
        "Publisher": "Federation of Indian Women Entrepreneurs (FIWE)",
        "URL": "fiwe.org",
        "App": "Not Available",
        "Avails": 6110720.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 36-45",
        "Publisher": "Sheroes",
        "URL": "sheroes.com",
        "App": "appliedlife.pvtltd.SHEROES",
        "Avails": 6109920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 36-45",
        "Publisher": "Pinkvilla",
        "URL": "pinkvilla.com",
        "App": "com.pinkvilla.bollywood",
        "Avails": 6107440.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 36-45",
        "Publisher": "HealthShots (HT Media)",
        "URL": "healthshots.com",
        "App": "com.healthshots",
        "Avails": 6096560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 36-45",
        "Publisher": "Clovia",
        "URL": "clovia.com",
        "App": "com.purplepanda.clovia",
        "Avails": 6076680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 36-45",
        "Publisher": "Vogue India",
        "URL": "vogue.in",
        "App": NaN,
        "Avails": 6071560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 36-45",
        "Publisher": "LBB (Little Black Book)",
        "URL": "lbb.in",
        "App": "Not Available",
        "Avails": 6040160.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 36-45",
        "Publisher": "Harper's Bazaar",
        "URL": "bazaarindia.in",
        "App": NaN,
        "Avails": 6033760.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 36-45",
        "Publisher": "Femina",
        "URL": "femina.in",
        "App": NaN,
        "Avails": 5980400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 36-45",
        "Publisher": "Cosmopolitan",
        "URL": "cosmopolitan.com",
        "App": "Not Available",
        "Avails": 5937920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 45+",
        "Publisher": "Miror",
        "URL": "Not Available",
        "App": "Not Available",
        "Avails": 5930280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 45+",
        "Publisher": "Femina",
        "URL": "femina.in",
        "App": "Not Available",
        "Avails": 5903400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 45+",
        "Publisher": "Sarita Magazine",
        "URL": "sarita.in",
        "App": "com.delhipress.sarita.android",
        "Avails": 5898960.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 45+",
        "Publisher": "Elle India",
        "URL": "elle.in",
        "App": "Not Available",
        "Avails": 5880720.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 45+",
        "Publisher": "The Peacock Magazine",
        "URL": "thepeacockmagazine.com",
        "App": "Not Available",
        "Avails": 5847960.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 45+",
        "Publisher": "Women Fitness India",
        "URL": "womenfitness.org",
        "App": "Not Available",
        "Avails": 5807720.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 45+",
        "Publisher": "Indian Express",
        "URL": "indianexpress.com",
        "App": "com.indianexpress.android",
        "Avails": 5807280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 45+",
        "Publisher": "Network18",
        "URL": "network18online.com",
        "App": "Not Available",
        "Avails": 5806880.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 45+",
        "Publisher": "NDTV",
        "URL": "ndtv.com",
        "App": "Not Available",
        "Avails": 5799960.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Age/Generational",
        "Category": "Women 45+",
        "Publisher": "The Times Group",
        "URL": "timesgroup.com",
        "App": "Not Available",
        "Avails": 5791560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Travel & Experience Seekers",
        "Category": "Travel Enthusiast",
        "Publisher": "EaseMyTrip",
        "URL": "easemytrip.com",
        "App": "com.easemytrip.in",
        "Avails": 5775240.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Travel & Experience Seekers",
        "Category": "Travel Enthusiast",
        "Publisher": "Agoda",
        "URL": "agoda.com",
        "App": "Not Available",
        "Avails": 5773120.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Travel & Experience Seekers",
        "Category": "Travel Enthusiast",
        "Publisher": "Tripadvisor",
        "URL": "tripadvisor.com",
        "App": "Not Available",
        "Avails": 5661080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Travel & Experience Seekers",
        "Category": "Travel Enthusiast",
        "Publisher": "Skyscanner India",
        "URL": "skyscanner.co.in",
        "App": "Not Available",
        "Avails": 5612120.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Travel & Experience Seekers",
        "Category": "Travel Enthusiast",
        "Publisher": "Booking.com",
        "URL": "booking.com",
        "App": "Not Available",
        "Avails": 5609040.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Travel & Experience Seekers",
        "Category": "Travel Enthusiast",
        "Publisher": "RedBus",
        "URL": "redbus.in",
        "App": "in.redbus.android",
        "Avails": 5608440.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Travel & Experience Seekers",
        "Category": "Travel Enthusiast",
        "Publisher": "Goibibo",
        "URL": "goibibo.com",
        "App": "com.goibibo.goibibo",
        "Avails": 5577200.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Travel & Experience Seekers",
        "Category": "Travel Enthusiast",
        "Publisher": "IndiGo",
        "URL": "goindigo.in",
        "App": "Not Available",
        "Avails": 5569000.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Travel & Experience Seekers",
        "Category": "Travel Enthusiast",
        "Publisher": "MakeMyTrip",
        "URL": "makemytrip.com",
        "App": "com.makemytrip",
        "Avails": 5520480.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Travel & Experience Seekers",
        "Category": "Travel Enthusiast",
        "Publisher": "Ixigo",
        "URL": "https://www.ixigo.com",
        "App": "Not Available",
        "Avails": 5473280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Work Profile",
        "Category": "Business owners",
        "Publisher": "Business Standard",
        "URL": "business-standard.com",
        "App": "Not Available",
        "Avails": 5470240.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Work Profile",
        "Category": "Business owners",
        "Publisher": "Business Today",
        "URL": "businesstoday.in",
        "App": "Not Available",
        "Avails": 5445920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Work Profile",
        "Category": "Business owners",
        "Publisher": "IndiaMART",
        "URL": "indiamart.com",
        "App": "com.indiamart.m",
        "Avails": 5399360.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Work Profile",
        "Category": "Business owners",
        "Publisher": "Naukri.com",
        "URL": "naukri.com",
        "App": "com.infoedge.naukri",
        "Avails": 5389280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Work Profile",
        "Category": "Business owners",
        "Publisher": "TradeIndia",
        "URL": "tradeindia.com",
        "App": "Not Available",
        "Avails": 5388760.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Work Profile",
        "Category": "Business owners",
        "Publisher": "Network18 Group",
        "URL": "network18online.com",
        "App": "Not Available",
        "Avails": 5367840.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Work Profile",
        "Category": "Business owners",
        "Publisher": "OfBusiness",
        "URL": "ofbusiness.com",
        "App": "Not Available",
        "Avails": 5351680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Work Profile",
        "Category": "Business owners",
        "Publisher": "TimesJobs",
        "URL": "timesjobs.com",
        "App": "Not Available",
        "Avails": 5348480.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Work Profile",
        "Category": "Business owners",
        "Publisher": "Shine.com",
        "URL": "shine.com",
        "App": "com.htmedia.shine",
        "Avails": 5326640.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Work Profile",
        "Category": "Business owners",
        "Publisher": "Monster India",
        "URL": "monsterindia.com",
        "App": "Not Available",
        "Avails": 5298080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Family and Parenting",
        "Category": "Family and Parenting",
        "Publisher": "IndiaParenting",
        "URL": "indiaparenting.com",
        "App": "Not Available",
        "Avails": 5265200.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Family and Parenting",
        "Category": "Family and Parenting",
        "Publisher": "The Champa Tree",
        "URL": "thechampatree.in",
        "App": "Not Available",
        "Avails": 5258520.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Family and Parenting",
        "Category": "Family and Parenting",
        "Publisher": "BabyChakra",
        "URL": "babychakra.com",
        "App": "com.babychakra.babychakra",
        "Avails": 5254400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Family and Parenting",
        "Category": "Family and Parenting",
        "Publisher": "TinyStep",
        "URL": "tinystep.in",
        "App": "Not Available",
        "Avails": 5224680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Family and Parenting",
        "Category": "Family and Parenting",
        "Publisher": "MomJunction",
        "URL": "momjunction.com",
        "App": "Not Available",
        "Avails": 5205000.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Family and Parenting",
        "Category": "Family and Parenting",
        "Publisher": "Kidsstoppress",
        "URL": "kidsstoppress.com",
        "App": "Not Available",
        "Avails": 5201440.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Family and Parenting",
        "Category": "Family and Parenting",
        "Publisher": "FirstCry",
        "URL": "firstcry.com",
        "App": "com.firstcry.baby",
        "Avails": 5187160.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Family and Parenting",
        "Category": "Family and Parenting",
        "Publisher": "BabyCenter India",
        "URL": "babycenter.in",
        "App": "Not Available",
        "Avails": 5184040.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Family and Parenting",
        "Category": "Family and Parenting",
        "Publisher": "SmartMom",
        "URL": "Not Available",
        "App": "Not Available",
        "Avails": 5157160.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Family and Parenting",
        "Category": "Family and Parenting",
        "Publisher": "Momspresso",
        "URL": "momspresso.com",
        "App": "com.momspresso.android",
        "Avails": 5142280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "Trakin Tech",
        "URL": "trak.in",
        "App": "com.trakintech.trakintech",
        "Avails": 5139680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "Gadgets360 (NDTV)",
        "URL": "gadgets360.com",
        "App": "com.ndtv.gadgets360",
        "Avails": 5106400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "Digit",
        "URL": "digit.in",
        "App": "com.thinkdigit.digit",
        "Avails": 5099280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "Android Authority",
        "URL": "androidauthority.com",
        "App": "com.androidauthority.app",
        "Avails": 5096000.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "TechRadar India",
        "URL": "techradar.com/in",
        "App": "Not Available",
        "Avails": 5084960.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "XDA Developers",
        "URL": "xda-developers.com",
        "App": "com.xda.labs",
        "Avails": 5073320.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "SamMobile",
        "URL": "sammobile.com",
        "App": "com.sammobile.app.free",
        "Avails": 5071280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "GSM Arena",
        "URL": "gsmarena.com",
        "App": "Not Available",
        "Avails": 5062600.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "Android Central",
        "URL": "androidcentral.com",
        "App": "Not Available",
        "Avails": 5053240.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "PhoneArena",
        "URL": "phonearena.com",
        "App": "Not Available",
        "Avails": 5048640.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Mobile Enthusiasts",
        "Publisher": "The Mobile Indian",
        "URL": "themobileindian.com",
        "App": "Not Available",
        "Avails": 5018000.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "Bolo Indya",
        "URL": "boloindya.com",
        "App": "Not Available",
        "Avails": 4988760.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "Roposo",
        "URL": "roposo.com",
        "App": "com.roposo.android",
        "Avails": 4979760.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "Trell",
        "URL": "trell.co",
        "App": "Not Available",
        "Avails": 4920920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "Dubsmash",
        "URL": "dubsmash.com",
        "App": "com.mobilemotion.dubsmash",
        "Avails": 4920120.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "WeChat",
        "URL": "wechat.com",
        "App": "com.tencent.xin",
        "Avails": 4919560.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "Viber",
        "URL": "viber.com",
        "App": "com.viber",
        "Avails": 4918680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "BharatMatrimony",
        "URL": "bharatmatrimony.com",
        "App": "com.bharatmatrimony",
        "Avails": 4915280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "Shaadi.com",
        "URL": "shaadi.com",
        "App": "com.shaadi.android",
        "Avails": 4895480.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "TrulyMadly",
        "URL": "trulymadly.com",
        "App": "com.trulymadly.android.app",
        "Avails": 4892280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "OkCupid",
        "URL": "okcupid.com",
        "App": "com.okcupid.okcupid",
        "Avails": 4887760.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Tech",
        "Category": "Social Media Enthusiasts",
        "Publisher": "Dubsmash",
        "URL": "com.mobilemotion.dubsmash",
        "App": "com.mobilemotion.dubsmash",
        "Avails": NaN
    },
    {
        "Geo": "India",
        "Audience Segment": "Health & Wellness",
        "Category": "Health & Fitness",
        "Publisher": "HealthifyMe",
        "URL": "healthifyme.com",
        "App": "com.healthifyme.basic",
        "Avails": 4870880.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Health & Wellness",
        "Category": "Health & Fitness",
        "Publisher": "Cult.fit",
        "URL": "cult.fit",
        "App": "fit.cure.android",
        "Avails": 4864640.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Health & Wellness",
        "Category": "Health & Fitness",
        "Publisher": "FITTR",
        "URL": "fittr.com",
        "App": "com.squats.fittr",
        "Avails": 4850400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Health & Wellness",
        "Category": "Health & Fitness",
        "Publisher": "Practo",
        "URL": "practo.com",
        "App": NaN,
        "Avails": 4849160.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Health & Wellness",
        "Category": "Health & Fitness",
        "Publisher": "StyleCraze",
        "URL": "stylecraze.com",
        "App": NaN,
        "Avails": 4832720.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Health & Wellness",
        "Category": "Health & Fitness",
        "Publisher": "Art of Living",
        "URL": "https://www.artofliving.org/in-en",
        "App": NaN,
        "Avails": 4825760.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Health & Wellness",
        "Category": "Health & Fitness",
        "Publisher": "Grow Fitter",
        "URL": "https://www.growfitter.com",
        "App": NaN,
        "Avails": 4780640.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Health & Wellness",
        "Category": "Health & Fitness",
        "Publisher": "MyFitnessPal",
        "URL": "myfitnesspal.com",
        "App": "com.myfitnesspal.android",
        "Avails": 4723680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Health & Wellness",
        "Category": "Health & Fitness",
        "Publisher": "FitCurry",
        "URL": "fitcurry.app",
        "App": "Not Available",
        "Avails": 4665400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Health & Wellness",
        "Category": "Health & Fitness",
        "Publisher": "Strava",
        "URL": "strava.com",
        "App": "com.strava",
        "Avails": 4660920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Sport",
        "Category": "Cricket - IPL",
        "Publisher": "BCCI (IPL Official)",
        "URL": "iplt20.com",
        "App": "com.bcci.ipl",
        "Avails": 4654640.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Sport",
        "Category": "Cricket - IPL",
        "Publisher": "ESPNcricinfo",
        "URL": "espncricinfo.com",
        "App": "com.espn.score_center.cricinfo",
        "Avails": 4634160.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Sport",
        "Category": "Cricket - IPL",
        "Publisher": "Cricbuzz",
        "URL": "cricbuzz.com",
        "App": "com.cricbuzz.android",
        "Avails": 4624040.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Sport",
        "Category": "Cricket - IPL",
        "Publisher": "NDTV Sports",
        "URL": "sports.ndtv.com",
        "App": "com.ndtv.india",
        "Avails": 4622160.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Sport",
        "Category": "Cricket - IPL",
        "Publisher": "Times of India Sports",
        "URL": "timesofindia.indiatimes.com/sports",
        "App": "com.toi.reader.activities",
        "Avails": 4608680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Sport",
        "Category": "Cricket - IPL",
        "Publisher": "Hindustan Times Sports",
        "URL": "hindustantimes.com/cricket",
        "App": "com.ht.news",
        "Avails": 4572880.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Sport",
        "Category": "Cricket - IPL",
        "Publisher": "Zee News (Cricket)",
        "URL": "zeenews.india.com/cricket",
        "App": "com.zeenews.india",
        "Avails": 4556320.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Sport",
        "Category": "Cricket - IPL",
        "Publisher": "Sportskeeda",
        "URL": "sportskeeda.com",
        "App": "com.sportskeeda.android",
        "Avails": 4550680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Sport",
        "Category": "Cricket - IPL",
        "Publisher": "India Today Sports",
        "URL": "indiatoday.in/sports",
        "App": "com.corp.india",
        "Avails": 4547080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Sport",
        "Category": "Cricket - IPL",
        "Publisher": "Republic World Sports",
        "URL": "republicworld.com/sports",
        "App": "com.rtv.republicworld",
        "Avails": 4541680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Beauty & Fitness- makeup & cosmetics",
        "Publisher": "Miss Malini",
        "URL": "https://www.missmalini.com",
        "App": NaN,
        "Avails": 4504760.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Beauty & Fitness- makeup & cosmetics",
        "Publisher": "Femina",
        "URL": "femina.in",
        "App": NaN,
        "Avails": 4502240.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Beauty & Fitness- makeup & cosmetics",
        "Publisher": "Vogue",
        "URL": "vogue.in",
        "App": NaN,
        "Avails": 4495720.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Beauty & Fitness- makeup & cosmetics",
        "Publisher": "PoPXO",
        "URL": "https://www.popxo.com",
        "App": NaN,
        "Avails": 4485040.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Beauty & Fitness- makeup & cosmetics",
        "Publisher": "Cosmopolitan",
        "URL": "cosmopolitan.com",
        "App": NaN,
        "Avails": 4483840.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Beauty & Fitness- makeup & cosmetics",
        "Publisher": "Daily Yoga",
        "URL": "dailyyoga.com",
        "App": NaN,
        "Avails": 4480160.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Beauty & Fitness- makeup & cosmetics",
        "Publisher": "Bazaar India",
        "URL": "bazaarindia.in",
        "App": NaN,
        "Avails": 4477360.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Beauty & Fitness- makeup & cosmetics",
        "Publisher": "Skincare Villa",
        "URL": "skincarevilla.com",
        "App": NaN,
        "Avails": 4455440.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Women",
        "Category": "Beauty & Fitness- makeup & cosmetics",
        "Publisher": "Glamshe",
        "URL": "glamshe.com",
        "App": NaN,
        "Avails": 4443680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Luxury & Status Seekers",
        "Category": "Luxury Shoppers",
        "Publisher": "Sheroes",
        "URL": "sheroes.com",
        "App": "appliedlife.pvtltd.SHEROES",
        "Avails": 4423680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Luxury & Status Seekers",
        "Category": "Luxury Shoppers",
        "Publisher": "Pinkvilla",
        "URL": "pinkvilla.com",
        "App": "com.pinkvilla.bollywood",
        "Avails": 4422280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Luxury & Status Seekers",
        "Category": "Luxury Shoppers",
        "Publisher": "HealthShots (HT Media)",
        "URL": "healthshots.com",
        "App": "com.healthshots",
        "Avails": 4421400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Luxury & Status Seekers",
        "Category": "Luxury Shoppers",
        "Publisher": "Magzter",
        "URL": "https://www.magzter.com",
        "App": NaN,
        "Avails": 4417080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Luxury & Status Seekers",
        "Category": "Luxury Shoppers",
        "Publisher": "Vogue India",
        "URL": "vogue.in",
        "App": NaN,
        "Avails": 4412600.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Luxury & Status Seekers",
        "Category": "Luxury Shoppers",
        "Publisher": "LBB (Little Black Book)",
        "URL": "lbb.in",
        "App": "Not Available",
        "Avails": 4409600.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Luxury & Status Seekers",
        "Category": "Luxury Shoppers",
        "Publisher": "Harper's Bazaar",
        "URL": "bazaarindia.in",
        "App": NaN,
        "Avails": 4404680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Luxury & Status Seekers",
        "Category": "Luxury Shoppers",
        "Publisher": "Femina",
        "URL": "femina.in",
        "App": NaN,
        "Avails": 4397680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Luxury & Status Seekers",
        "Category": "Luxury Shoppers",
        "Publisher": "Cosmopolitan",
        "URL": "cosmopolitan.com",
        "App": "Not Available",
        "Avails": 4393440.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Luxury & Status Seekers",
        "Category": "Luxury Shoppers",
        "Publisher": "Grazia",
        "URL": "https://www.grazia.co.in",
        "App": NaN,
        "Avails": 4404680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "pet owners",
        "Category": "Pet owners",
        "Publisher": "PetBacker",
        "URL": "petbacker.in",
        "App": "Not Available",
        "Avails": 4349880.0
    },
    {
        "Geo": "India",
        "Audience Segment": "pet owners",
        "Category": "Pet owners",
        "Publisher": "Wagr",
        "URL": "wagr.ai",
        "App": "Not Available",
        "Avails": 4347840.0
    },
    {
        "Geo": "India",
        "Audience Segment": "pet owners",
        "Category": "Pet owners",
        "Publisher": "Supertails",
        "URL": "supertails.com",
        "App": "Not Available",
        "Avails": 4333680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "pet owners",
        "Category": "Pet owners",
        "Publisher": "Petsy",
        "URL": "petsy.online",
        "App": "Not Available",
        "Avails": 4325440.0
    },
    {
        "Geo": "India",
        "Audience Segment": "pet owners",
        "Category": "Pet owners",
        "Publisher": "Petsfolio",
        "URL": "petsfolio.com",
        "App": "Not Available",
        "Avails": 4313760.0
    },
    {
        "Geo": "India",
        "Audience Segment": "pet owners",
        "Category": "Pet owners",
        "Publisher": "Wiggles",
        "URL": "wiggles.in",
        "App": "Not Available",
        "Avails": 4301920.0
    },
    {
        "Geo": "India",
        "Audience Segment": "pet owners",
        "Category": "Pet owners",
        "Publisher": "All Tails",
        "URL": "alltails.com",
        "App": "Not Available",
        "Avails": 4287320.0
    },
    {
        "Geo": "India",
        "Audience Segment": "pet owners",
        "Category": "Pet owners",
        "Publisher": "11pets",
        "URL": "11pets.com",
        "App": "com.m11pets.elevenpets",
        "Avails": 4274120.0
    },
    {
        "Geo": "India",
        "Audience Segment": "pet owners",
        "Category": "Pet owners",
        "Publisher": "Pet Warehouse",
        "URL": "petwarehouse.shop",
        "App": "Not Available",
        "Avails": 4272280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Music lovers",
        "Category": "Music lovers",
        "Publisher": "Boomplay",
        "URL": "boomplay.com",
        "App": "Not Available",
        "Avails": 4261080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Music lovers",
        "Category": "Music lovers",
        "Publisher": "Hungama Music",
        "URL": "hungama.com",
        "App": "Not Available",
        "Avails": 4260280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Music lovers",
        "Category": "Music lovers",
        "Publisher": "TIDAL",
        "URL": "tidal.com",
        "App": "Not Available",
        "Avails": 4249880.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Music lovers",
        "Category": "Music lovers",
        "Publisher": "Musixmatch",
        "URL": "musixmatch.com",
        "App": "Not Available",
        "Avails": 4237280.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Music lovers",
        "Category": "Music lovers",
        "Publisher": "Pandora",
        "URL": "pandora.com",
        "App": "Not Available",
        "Avails": 4233720.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Music lovers",
        "Category": "Music lovers",
        "Publisher": "Napster",
        "URL": "napster.com",
        "App": "Not Available",
        "Avails": 4208960.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Music lovers",
        "Category": "Music lovers",
        "Publisher": "Gaana HotShots",
        "URL": "gaana.com",
        "App": "Not Available",
        "Avails": 4207040.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Music lovers",
        "Category": "Music lovers",
        "Publisher": "Audiomack",
        "URL": "audiomack.com",
        "App": "com.audiomack.audiomack",
        "Avails": 4204200.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Music lovers",
        "Category": "Music lovers",
        "Publisher": "JioTunes",
        "URL": "jio.com",
        "App": "Not Available",
        "Avails": 4169720.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Music lovers",
        "Category": "Music lovers",
        "Publisher": "Saregama Carvaan",
        "URL": "saregama.com",
        "App": "Not Available",
        "Avails": 4141000.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Automobile",
        "Category": "Auto-Enthusiast",
        "Publisher": "Autocar India",
        "URL": "autocarindia.com",
        "App": "Not Available",
        "Avails": 4134840.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Automobile",
        "Category": "Auto-Enthusiast",
        "Publisher": "Overdrive",
        "URL": "overdrive.in",
        "App": "Not Available",
        "Avails": 4130080.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Automobile",
        "Category": "Auto-Enthusiast",
        "Publisher": "Carandbike",
        "URL": "carandbike.com",
        "App": "Not Available",
        "Avails": 4125600.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Automobile",
        "Category": "Auto-Enthusiast",
        "Publisher": "CarWale",
        "URL": "carwale.com",
        "App": "com.carwale",
        "Avails": 4120160.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Automobile",
        "Category": "Auto-Enthusiast",
        "Publisher": "Car India",
        "URL": "carindia.in",
        "App": "Not Available",
        "Avails": 4119680.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Automobile",
        "Category": "Auto-Enthusiast",
        "Publisher": "Bike India",
        "URL": "bikeindia.in",
        "App": "Not Available",
        "Avails": 4119400.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Automobile",
        "Category": "Auto-Enthusiast",
        "Publisher": "ZigWheels",
        "URL": "zigwheels.com",
        "App": "Not Available",
        "Avails": 4074640.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Automobile",
        "Category": "Auto-Enthusiast",
        "Publisher": "CarDekho",
        "URL": "cardekho.com",
        "App": "com.girnar.cardekho",
        "Avails": 4070840.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Automobile",
        "Category": "Auto-Enthusiast",
        "Publisher": "CarTrade",
        "URL": "cartrade.com",
        "App": "com.mx.cartrade",
        "Avails": 4070800.0
    },
    {
        "Geo": "India",
        "Audience Segment": "Automobile",
        "Category": "Auto-Enthusiast",
        "Publisher": "AutoPortal",
        "URL": "autoportal.com",
        "App": "Not Available",
        "Avails": 4038520.0
    }
]
